// Auto-generated by scripts/generateFactionSkinConfig.mjs
// Do not edit manually.

// eslint-disable-next-line no-unused-vars
import {FACTIONS} from '../../../constants/factions';
// eslint-disable-next-line no-unused-vars
import {PLAYER_COLORS} from '../../colors';

export const FACTION_SKINS_SPIRITS = [{
  id: 'spirits_miner',
  factionId: FACTIONS.SPIRITS,
  name: 'Хозяин рудника',
  priceNumens: 4000,
  skinRank: 1,
}, {
  id: 'spirits_egypt',
  factionId: FACTIONS.SPIRITS,
  name: 'Фараон',
  priceNumens: 35000,
  skinRank: 2,
  colors: [
    PLAYER_COLORS.ORANGE,
    PLAYER_COLORS.YELLOW,
  ]
}, {
  id: 'spirits_space',
  factionId: FACTIONS.SPIRITS,
  name: 'Дыхание Вселенной',
  priceNumens: 100000,
  skinRank: 3,
  colors: [
    PLAYER_COLORS.INDIGO,
    PLAYER_COLORS.VIOLET,
    PLAYER_COLORS.PURPLE,
    PLAYER_COLORS.BLUE,
    PLAYER_COLORS.SKY_BLUE,
    PLAYER_COLORS.CELADON,
  ]
}, {
  id: 'spirits_gold_legacy',
  factionId: FACTIONS.SPIRITS,
  name: 'Безликий оракул',
  priceNumens: 70000,
  skinRank: 3,
  colors: [
    PLAYER_COLORS.YELLOW,
  ],
  excludedFromChests: true
}, {
  id: 'spirits_ruby_legacy',
  factionId: FACTIONS.SPIRITS,
  name: 'Звездочёт',
  priceCrystals: 450,
  skinRank: 4,
  colors: [
    PLAYER_COLORS.VIOLET,
    PLAYER_COLORS.RED,
  ],
  accentColor: PLAYER_COLORS.RED,
  excludedFromChests: true
}];
